import React from "react";
import { PageHeader, List } from "antd";
import styles from "./OptinList.module.scss";
import { SnippetsOutlined } from "@ant-design/icons";
const { optInSelectTemplate, optInSelectTemplate__full, optInList__content } = styles;
function OptinSelectTemplate({ templates, visible, closeCb, selectTemplateCb }) {
    return (
        <div className={`${optInSelectTemplate} ${visible && optInSelectTemplate__full}`}>
            <PageHeader onBack={() => closeCb()} title="" subTitle={"Seleccionar template"} />
            <div className={optInList__content}>
                <List
                    rowKey={(item) => item.id}
                    dataSource={templates}
                    renderItem={(item) => (
                        <List.Item>
                            <List.Item.Meta
                                avatar={<SnippetsOutlined />}
                                description={item.text}
                                onClick={() => selectTemplateCb(item)}
                            />
                        </List.Item>
                    )}
                />
            </div>
        </div>
    );
}
export default OptinSelectTemplate;
